import { useAppState } from '@/state/app';

type SetPageFn<T extends Record<string, unknown>> = (fn: ((current: T) => T) | T) => void;

//TODO: Update app state selector logic to setAppState the same way setPage does but can handle deeply nested state using the selector
const usePage = <T extends Record<string, unknown> = Record<string, unknown>>(page: string): [T, SetPageFn<T>] => {
  const [state, setState] = useAppState();
  const pageState: T = state?.page?.[page] || {};

  const setPage: SetPageFn<T> = (fn): void => {
    setState((current) => ({
      ...current,
      page: {
        ...(current?.page || {}),
        [page]: typeof fn === 'function' ? fn(current?.page?.[page]) : fn,
      },
    }));
  };

  return [pageState, setPage];
};

export default usePage;
